// @ts-nocheck
import {
  REPORTING_ADVANCED_FILTER_DELETE_MAP,
  REPORTING_ADVANCED_FILTER_RESET,
  REPORTING_ADVANCED_FILTER_RESET_CARTOGRAPHY,
  REPORTING_ADVANCED_FILTER_RESET_SECTION,
  REPORTING_ADVANCED_FILTER_SET_CAMPAIGN_IDS,
  REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_COUNTRIES,
  REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL,
  REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_CATALOG,
  REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_IDS,
  REPORTING_ADVANCED_FILTER_SET_CHARTS_TIME_STEP,
  REPORTING_ADVANCED_FILTER_SET_COUNTRY,
  REPORTING_ADVANCED_FILTER_SET_CURRENCY,
  REPORTING_ADVANCED_FILTER_SET_INSIGHT_COUNTRY,
  REPORTING_ADVANCED_FILTER_SET_MAPS,
  REPORTING_ADVANCED_FILTER_SET_SETTINGS,
  REPORTING_ADVANCED_FILTER_SET_TABLE_TIME_STEP,
  REPORTING_ADVANCED_FILTER_SET_TABLES_TIME_STEP,
  REPORTING_ADVANCED_FILTER_SET_TIME_FRAME,
  REPORTING_ADVANCED_FILTER_SET_TIME_RANGE,
  REPORTING_ADVANCED_FILTER_SET_TIMEZONE
} from '@/store/actions/reportingAdvancedFilter.actions';

const updateSections = (section, sections, settings) => {
  if (section === 'general') {
    const { cartographyLevel, cartographyLevelIds, ...restSettings } = settings;
    return Object.entries(sections).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: {
          ...value,
          ...(key === 'general' ? settings : restSettings),
          ...(key === 'insights' ? { insightCountry: undefined } : {})
        }
      }),
      {}
    );
  }

  return {
    ...sections,
    [section]: {
      ...sections[section],
      ...settings,
      ...(section === 'insights' && {
        insightCountry: undefined
      })
    }
  };
};

const initialCartographyMap = {
  cartographyCountries: [],
  cartographyLevel: '',
  cartographyLevelIds: []
};

const sectionInitialState = {
  cartographyCountries: [],
  cartographyLevel: '',
  cartographyLevelIds: [],
  cartographyLevelIdsCatalog: [],
  chartTimeStep: 'day',
  currency: '',
  tablesTimeStep: {
    footfallAttribution: 'day',
    stats: 'day',
    viewability: 'day'
  },
  timeFrame: {
    beginDate: '',
    endDate: '',
    hasCustomDates: false
  },
  timeRange: 'fromStart',
  timeZone: 'Europe/Madrid',
  variableType: '',
  variableValues: []
};

const initialStore = {
  cids: [],
  sections: {
    campaignsProgress: sectionInitialState,
    footfallAttribution: sectionInitialState,
    footfallAttributionInsightsByStore: sectionInitialState,
    general: sectionInitialState,
    insights: sectionInitialState,
    maps: sectionInitialState,
    summary: sectionInitialState,
    table: sectionInitialState
  }
};

const actionsMap = {
  [REPORTING_ADVANCED_FILTER_SET_CAMPAIGN_IDS]: (store, action) => {
    const { cids } = action.data;
    return {
      ...store,
      cids
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CURRENCY]: (store, action) => {
    const { currency, section } = action.data;
    return {
      ...store,
      sections: {
        ...(section === 'general'
          ? Object.entries(store.sections).reduce(
              (prev, [sectionKey, sectionConfig]) => ({
                ...prev,
                [sectionKey]: {
                  ...sectionConfig,
                  currency
                }
              }),
              {}
            )
          : {
              ...store.sections,
              [section]: {
                ...store.sections[section],
                currency
              }
            })
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_TIME_RANGE]: (store, action) => {
    const { section, timeRange } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          timeRange
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_TIME_FRAME]: (store, action) => {
    const { hasCustomDates, section, timeFrame } = action.data;
    updateSections(section, store.sections, {
      timeFrame: {
        ...timeFrame,
        hasCustomDates
      }
    });
    return {
      ...store,
      sections: {
        ...store.sections,
        ...updateSections(section, store.sections, { timeFrame })
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_TIMEZONE]: (store, action) => {
    const { section, timeZone } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        ...(section === 'general'
          ? Object.entries(store.sections).reduce(
              (prev, [sectionKey, sectionConfig]) => ({
                ...prev,
                [sectionKey]: {
                  ...sectionConfig,
                  timeZone
                }
              }),
              {}
            )
          : {
              ...store.sections,
              [section]: {
                ...store.sections[section],
                timeZone
              }
            })
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_SETTINGS]: (store, action) => {
    const {
      section,
      settings: {
        beginDate,
        cartographyCountries,
        cartographyLevel,
        cartographyLevelIds,
        cartographyLevelIdsNames,
        chartTimeStep,
        currency,
        endDate,
        tablesTimeStep,
        timeFrame,
        timeRange,
        timeZone,
        variableType,
        variableValues,
        variableValuesNames
      }
    } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        ...updateSections(section, store.sections, {
          beginDate,
          cartographyCountries,
          cartographyLevel,
          cartographyLevelIds,
          cartographyLevelIdsNames,
          chartTimeStep,
          currency,
          endDate,
          tablesTimeStep,
          timeFrame,
          timeRange,
          timeZone,
          variableType,
          variableValues,
          variableValuesNames
        })
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_RESET]: () => {
    return initialStore;
  },
  [REPORTING_ADVANCED_FILTER_RESET_SECTION]: (store, action) => {
    const { section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections.general
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_MAPS]: (store, action) => {
    const { mapId } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        maps: {
          ...store.sections.maps,
          [mapId]: initialCartographyMap
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_DELETE_MAP]: (store, action) => {
    const { mapId } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        maps: Object.entries(store.sections.maps).reduce((acc, [key, value]) => {
          if (key !== mapId) {
            return {
              ...acc,
              [key]: value
            };
          }
          return acc;
        }, {})
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_RESET_CARTOGRAPHY]: (store, action) => {
    const { mapId, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          [mapId]: initialCartographyMap
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_COUNTRIES]: (store, action) => {
    const { cartographyCountries, mapId, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          [mapId]: {
            ...store.sections[section][mapId],
            cartographyCountries,
            ...(section === 'insights' && {
              insightCountry: undefined
            })
          }
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL]: (store, action) => {
    const { cartographyLevel, mapId, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          [mapId]: {
            ...store.sections[section][mapId],
            cartographyLevel
          }
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_IDS]: (store, action) => {
    const { cartographyLevelIds, mapId, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          [mapId]: {
            ...store.sections[section][mapId],
            cartographyLevelIds
          }
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CARTOGRAPHY_LEVEL_CATALOG]: (store, action) => {
    const { cartographyLevelIdsCatalog, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          cartographyLevelIdsCatalog
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_TABLE_TIME_STEP]: (store, action) => {
    const { section, table, timeStep } = action.data;
    return {
      ...store,
      sections: {
        [section]: {
          ...store.sections[section],
          tablesTimeStep: {
            ...store.tablesTimeStep,
            [`${table}tableTimeStep`]: timeStep
          }
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_TABLES_TIME_STEP]: (store, action) => {
    const { section, tablesTimeStep } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          tablesTimeStep
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_CHARTS_TIME_STEP]: (store, action) => {
    const { section, timeStep } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          chartTimeStep: timeStep
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_COUNTRY]: (store, action) => {
    const { country, section } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        [section]: {
          ...store.sections[section],
          country
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_INSIGHT_COUNTRY]: (store, action) => {
    const { country, insightId } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        insights: {
          ...store.sections.insights,
          insightCountry: {
            [insightId]: country
          }
        }
      }
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
